import Vue from 'vue'
import '@/plugins'
import mixins from '@/views/mixins'
import filters from '@/views/filters'
import VueChatScroll from 'vue-chat-scroll'

class Register {

    registerAll() {
        Vue.use(mixins)
        Vue.use(filters)
        Vue.use(VueChatScroll)
    }

}

export default new Register()
